import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { CustomerSelectItem, JobsiteSelectItem, EquipmentSelectItem, Equipment, Tuple, CustomerSelectItemVM, EquipmentDetailsParams, MakeSetupVM } from './setup-equipment.model';
import { EquipmentInspectionForcastingViewModel } from '../equipment-details/equipment-details.model';
import { Make } from '../../../entities';
import { GETGenericIdName } from '../setup-implement/setup-implement.model';


@Injectable()
export class GETSetupEquipmentService {
  private readonly API_BASE = 'api/GETsetupequipment/';
  private readonly GET_CUSTOMER_LIST = this.API_BASE + 'GetCustomerList';
  private readonly GET_JOBSITE_LIST = this.API_BASE + 'GetJobsiteList';
  private readonly GET_EQUIPMENT_LIST = this.API_BASE + 'GetEquipmentList';
  private readonly GET_MAKES = this.API_BASE + 'GetMakeList';
  private readonly GET_MODELS = this.API_BASE + 'GetModelList';
  private readonly GET_FAMILY_NAME_FOR_MODEL = this.API_BASE + 'GetFamilyNameForModel';
  private readonly GET_EQUIPMENT_RANKING_LIST = this.API_BASE + 'GetEquipmentRankingListAsync';
  private readonly GET_APPLICATION_LIST = this.API_BASE + 'GetEquipmentApplicationListAsync';
  private readonly VALIDATE_SERIAL_UNIT_NUMBER = this.API_BASE + 'ValidateSerialAndUnitNumberAsync';
  private readonly CREATE_NEW_EQUIPMENT = this.API_BASE + 'CreateNewEquipment';
  private readonly GET_EQUIPMENT_SETUP_DETAILS = this.API_BASE + 'GetEquipmentSetupDetails';
  private readonly UPDATE_EQUIPMENT = this.API_BASE + 'UpdateEquipmentAsync';
  private readonly GET_EQUIPMENT_DETAILS =this.API_BASE+ 'GetEquipmentDetails';
  private readonly UPDATE_INSPECTION_FORECAST = this.API_BASE + 'UpdateEquipmentInspectionForcast';
  private readonly GET_IMPLEMENTS_BY_JOBSITE = this.API_BASE + 'GetImplementsByJobsite';
  constructor(private _http: Http) { }

  public getEquipmentSetupDetails(equipmentId: number): Observable<Equipment> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get(this.GET_EQUIPMENT_SETUP_DETAILS, { search: params }).share().map(
      (response: Response) => <Equipment>response.json()).catch(this.handleError);
  }

  
  

public updateInspectionForecast(model: EquipmentInspectionForcastingViewModel): Observable<Tuple> {
  return this._http.post(this.UPDATE_INSPECTION_FORECAST, model).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

  public updateEquipment(equipment: Equipment): Observable<Tuple> {
    return this._http.post(this.UPDATE_EQUIPMENT, equipment).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }

  public createNewEquipment(equipment: Equipment): Observable<Tuple> {
    return this._http.post(this.CREATE_NEW_EQUIPMENT, equipment).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }

  public getCustomerList(): Observable<CustomerSelectItem[]> {
    return this._http.get(this.GET_CUSTOMER_LIST).share().map(
      (response: Response) => <CustomerSelectItem[]>response.json()).catch(this.handleError);
  }

  public getJobsiteList(customerId: number): Observable<JobsiteSelectItem[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('customerId', customerId.toString());
    return this._http.get(this.GET_JOBSITE_LIST, { search: params }).share().map(
      (response: Response) => <JobsiteSelectItem[]>response.json()).catch(this.handleError);
  }

  
  
  

  public getEquipmentList(jobsiteId: number): Observable<EquipmentSelectItem[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('jobsiteId', jobsiteId.toString());
    return this._http.get(this.GET_EQUIPMENT_LIST, { search: params }).share().map(
      (response: Response) => <EquipmentSelectItem[]>response.json()).catch(this.handleError);
  }

  public getMakeList(): Observable<CustomerSelectItem[]> {
    return this._http.get(this.GET_MAKES).share().map(
      (response: Response) => <CustomerSelectItem[]>response.json()).catch(this.handleError);
  }

  
  public GetImplementsAvailable(): Observable<CustomerSelectItem[]> {
    return this._http.get(this.GET_MAKES).share().map(
      (response: Response) => <CustomerSelectItem[]>response.json()).catch(this.handleError);
  }
 

  public getModelList(makeId: number): Observable<JobsiteSelectItem[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('makeId', makeId.toString());
    return this._http.get(this.GET_MODELS, { search: params }).share().map(
      (response: Response) => <JobsiteSelectItem[]>response.json()).catch(this.handleError);
  }

  public getFamilyNameForModel(modelId: number): Observable<string> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('modelId', modelId.toString());
    return this._http.get(this.GET_FAMILY_NAME_FOR_MODEL, { search: params }).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }

  public getEquipmentRankingList(): Observable<CustomerSelectItem[]> {
    return this._http.get(this.GET_EQUIPMENT_RANKING_LIST).share().map(
      (response: Response) => <CustomerSelectItem[]>response.json()).catch(this.handleError);
  }

  public getEquipmentApplicationList(): Observable<CustomerSelectItem[]> {
    return this._http.get(this.GET_APPLICATION_LIST).share().map(
      (response: Response) => <CustomerSelectItem[]>response.json()).catch(this.handleError);
  }

  public getJobsitesForSelectedCustomers(customerIds: number[]): Observable<JobsiteSelectItem[]> {
    let params :URLSearchParams = new URLSearchParams();
    params.set('customerIds', customerIds.toString());
    return this._http.get('api/GETjobsite/jobsiteListForCustomerList',  { search: params } ).share().map(
      (response: Response) => <JobsiteSelectItem[]>response.json()).catch(this.handleError);
  }

  public validateEquipmentSerialAndUnit(serialNumber: string, unitNumber: string, equipmentId: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('serialNumber', serialNumber);
    params.set('unitNumber', unitNumber);
    if (equipmentId > 0)
      params.set('equipmentId', equipmentId.toString());
    return this._http.get(this.VALIDATE_SERIAL_UNIT_NUMBER, { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public getEquipmentDetails(equipmentId: number): Observable<EquipmentDetailsParams> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get(this.GET_EQUIPMENT_DETAILS, { search: params }).share().map(
      (response: Response) => <EquipmentDetailsParams>response.json()).catch(this.handleError);
  }

  public getMinDateForEquipmentSetup(equipmentId: number): Observable<string> {
      let params: URLSearchParams = new URLSearchParams();
      params.set('equipmentId', equipmentId.toString());
      return this._http.get('api/GETEquipment/getMinDateForEquipmentSetup', { search: params }).share().map(
          (response: Response) => <string>response.json()).catch(this.handleError);
  }


  public AddnewMake(make: MakeSetupVM): Observable<Tuple> {
    return this._http.post('api/GETEquipment/AddnewMake', make).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }

  public UpdateMake(make: MakeSetupVM): Observable<Tuple> {
    return this._http.post('api/GETEquipment/UpdateMake', make).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }

  public DeleteMake(make: MakeSetupVM): Observable<Tuple> {
    return this._http.post('api/GETEquipment/DeleteMake', make).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }
  public getMakeListFoeSetUp(): Observable<Make[]> {
    return this._http.get('api/GETEquipment/getMakeListFoeSetUp').share().map(
      (response: Response) => <Make[]>response.json()).catch(this.handleError);
  }
  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

  public getImpsByJobsite(jobsiteId: number): Observable<GETGenericIdName[]> {
    return this._http.get(`Api/GETDashboard/GetImplementsByJobsite?jobsiteId=${jobsiteId}`)
      .map((response: Response) => <GETGenericIdName[]>response.json())
      .catch(this.handleError);
  }

//   public getMakeFromFamilyNew(model: MakeSetupVMNew[]): Observable<Tuple> {
//     return this._http.post(this.GET_MAKES_NEW, model).share().map(
//       (response: Response) => <Tuple>response.json()).catch(this.handleError);
//   }
}
